module.exports = __webpack_public_path__ + "img/logo.bf70c442.png";